import Moment from 'moment'

const convertJsonToCSV = {
  objectToCSV (data) {
    const csvRows = []

    const headers = Object.values(data[0])
    csvRows.push(headers.join(','))

    const ref = Object.keys(data[0])
    data.shift()

    for (const row of data) {
      const values = ref.map(header => {
        const scaped = ('' + row[header]).replace(/"/g, '""')
        return `"${scaped}"`
      })
      csvRows.push(values.join(','))
    }

    return csvRows.join('\n')
  },

  downloadCSVFile (headers, items, fileTitle) {
    if (headers) {
      items.unshift(headers)
    }

    const csv = this.objectToCSV(items)
    const exportedFilename = fileTitle + '.csv'

    const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8' + encodeURI(blob) })

    if (navigator.msSaveBlob) {
      navigator.msSaveBlob(blob, exportedFilename)
    } else {
      let link = document.createElement('a')
      if (link.download !== undefined) {
        let url = URL.createObjectURL(blob)
        link.setAttribute('href', url)
        link.setAttribute('download', exportedFilename)
        link.style.visibility = 'hidden'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
    }
  },

  buildObjectToCSV (itemsNotFormatted, headers, fileName) {
    let itemsFormatted = []

    itemsNotFormatted.forEach((item) => {
      itemsFormatted.push({
        idLab: item.laboratory.code,
        osAlvaro: item.order.alvaroId,
        date: Moment(item.exam.result.releaseDate)
          .locale('pt-br')
          .format('DD/MM/YYYY HH:mm'),
        namePatient: item.order.patient.name,
        exam: item.exam.mnemonic + ' - ' + item.exam.description,
        material: item.exam.material.name,
        result: item.exam.result.description
      })
    })

    const fileTitle = fileName + new Date().toLocaleString()

    this.downloadCSVFile(headers, itemsFormatted, fileTitle) // call the downloadCSVFile() function to process the JSON and trigger the download
  }
}

export default convertJsonToCSV
